<template>
  <b-modal centered id="edit-manage-info" modal-class="overflow-hidden" static scrollable size="xl">
    <template #modal-header="">
      <h5>Sửa TT quản lý</h5>
      <b-button size="sm" variant="light" @click="closeModalRequestDevice()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo">
      <div>
        <div class="form-group">
          <label>Bộ phận vừa xử lý</label>
          <Select2
            v-model="dataRequest.workUnit"
            :options="Config.resultCalendarAfs"
            placeholder="Chọn bộ phận vừa xử lý"
          />
        </div>
        <div class="form-group">
          <label>Bộ phận đang xử lý</label>
          <Select2
            v-model="dataRequest.workingUnit"
            :options="Config.resultCalendarAfs"
            placeholder="Chọn bộ phận đang xử lý"
          />
        </div>
        <div class="form-group">
          <label>Thời hạn bước hiện tại</label>
          <InputRange v-model="dateRange"></InputRange>
        </div>
        <div class="form-group">
          <label>Thời hạn ticket</label>
          <InputRange v-model="dateRange"></InputRange>
        </div>
        <div class="form-group">
          <label>Mức độ ưu tiên</label>
          <Select2
            v-model="dataRequest.workingUnit"
            :options="Config.resultCalendarAfs"
            placeholder="Chọn mức độ ưu tiên"
          />
        </div>
        <div class="form-group">
          <label>Loại công việc</label>
          <Select2
            v-model="dataRequest.workingUnit"
            :options="Config.resultCalendarAfs"
            placeholder="Chọn loại công việc"
          />
        </div>
      </div>
    </form>
    <template #modal-footer="{ closeModalRequestDevice }">
      <b-button
        class="btn-style"
        size="sm"
        type="button"
        variant="light"
        @click="closeModalRequestDevice()"
      >
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary"> Xác nhận </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  import InputRange from '@/components/InputRange.vue'
  export default {
    name: 'modal-device',
    props: {
      dataOption: {
        type: Object,
      },
      closeModalRequestDevice: {
        type: Function,
      },
    },
    data() {
      return {
        Config,
        showLoading: false,
        dataRequest: {},
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
    },
    components: { InputRange },
    methods: {
      async updateInfo() {
        const data = this.dataRequest
        console.log(data)
        this.$emit('updateInfo', data)
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
</style>
